import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification } from '../../actions/notifications';
import { Notifications } from '../../components/Notifications';
import { selectNotifications } from '../../selectors/notifications';
import { INotification } from '../../types/notifications';

export const NotificationsContainer = () => {
  const notifications = useSelector(selectNotifications);
  const dispatch = useDispatch();

  const handleNotificationRemove = React.useCallback(
    (notification: INotification) => {
      dispatch(removeNotification(notification.id));
    },
    [dispatch],
  );

  return <Notifications notifications={notifications} onNotificationRemove={handleNotificationRemove} />;
};
